/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatXlsIcon16Light } from './FileFormatXlsIcon16Light';
import { FileFormatXlsIcon16Regular } from './FileFormatXlsIcon16Regular';
import { FileFormatXlsIcon16Solid } from './FileFormatXlsIcon16Solid';
import { FileFormatXlsIcon20Light } from './FileFormatXlsIcon20Light';
import { FileFormatXlsIcon20Regular } from './FileFormatXlsIcon20Regular';
import { FileFormatXlsIcon20Solid } from './FileFormatXlsIcon20Solid';
import { FileFormatXlsIcon24Regular } from './FileFormatXlsIcon24Regular';
import { FileFormatXlsIcon24Solid } from './FileFormatXlsIcon24Solid';
import { FileFormatXlsIcon32Regular } from './FileFormatXlsIcon32Regular';
import { FileFormatXlsIcon64Regular } from './FileFormatXlsIcon64Regular';
var sizes = {
    16: {
        light: FileFormatXlsIcon16Light,
        regular: FileFormatXlsIcon16Regular,
        solid: FileFormatXlsIcon16Solid,
    },
    20: {
        light: FileFormatXlsIcon20Light,
        regular: FileFormatXlsIcon20Regular,
        solid: FileFormatXlsIcon20Solid,
    },
    24: {
        regular: FileFormatXlsIcon24Regular,
        solid: FileFormatXlsIcon24Solid,
    },
    32: {
        regular: FileFormatXlsIcon32Regular,
    },
    64: {
        regular: FileFormatXlsIcon64Regular,
    },
};
export var FileFormatXlsIcon = forwardRef('FileFormatXlsIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
